import type React from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../components/FormElements/TextInput'
import { Button } from '../../../components/ui/Button'
import { useGetUser } from '../../../api/auth/useGetUser'
import { useEffect } from 'react'

interface UserDataSectionProps {
  isEditing: boolean
  onCancel: () => void
}

export const UserDataSection: React.FC<UserDataSectionProps> = ({
  isEditing,
  onCancel,
}) => {
  const { data: userData } = useGetUser()
  const { reset } = useFormContext()

  useEffect(() => {
    reset({
      ...userData,
    })
  }, [userData, reset])

  if (!isEditing) {
    return (
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-md text-foreground dark:text-white font-bold">
              First Name
            </h3>
            <p className="mt-1 text-sm text-foreground dark:text-white">
              {userData?.first_name}
            </p>
          </div>
          <div>
            <h3 className="text-md font-bold text-foreground dark:text-white">
              Last Name
            </h3>
            <p className="mt-1 text-sm text-foreground dark:text-white">
              {userData?.last_name}
            </p>
          </div>
          <div>
            <h3 className="ttext-md font-bold text-foreground dark:text-white">Email</h3>
            <p className="mt-1 text-sm text-foreground dark:text-white">
              {userData?.email}
            </p>
          </div>
          <div>
            <h3 className="text-md font-bold text-foreground dark:text-white">
              Phone Number
            </h3>
            <p className="mt-1 text-sm text-foreground dark:text-white">
              {userData?.phone}
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <TextInput name="first_name" label="First Name" required />
      <TextInput name="last_name" label="Last Name" required />
      <TextInput
        name="email"
        label="Email"
        type="email"
        required
        rules={{
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Invalid email address',
          },
        }}
      />
      <TextInput name="phone" label="Phone Number" />
      <div className="flex justify-end space-x-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Save</Button>
      </div>
    </div>
  )
}
